import { AppSetting } from './../services/app-settings.service';

const INITIAL_STATE: AppSettingsState = {
  Settings : [],
  ApplicationNavigation: [],
  IsLoaded: false
};

const APP_SETTINGS = 'APP_SETTINGS';
export const AppSettingActions = {
  INIT: `${APP_SETTINGS}.INIT`,
  SET_SETTINGS: `${APP_SETTINGS}.SET_SETTINGS`,
  SET_SETTING: `${APP_SETTINGS}.SET_SETTING`,
  SET_IS_LOADED: `${APP_SETTINGS}.SET_IS_LOADED`,
  SET_APPLICATION_NAVIGATION: `${APP_SETTINGS}.SET_APPLICATION_NAVIGATION`,
};

export function AppSettingsReducer(state: AppSettingsState = INITIAL_STATE, action: any) {
  switch (action.type) {
    case AppSettingActions.INIT:
      state = INITIAL_STATE;
      return state;
    case AppSettingActions.SET_SETTINGS:
      state.Settings = action.payload;
      return state;
    case AppSettingActions.SET_SETTING:
      state.Settings.push(action.payload);
      return state;
    case AppSettingActions.SET_IS_LOADED:
      state.IsLoaded = action.payload;
      return state;
    case AppSettingActions.SET_APPLICATION_NAVIGATION:
      state.ApplicationNavigation = action.payload;
      return state;
    default:
      return state;
  }
}

export interface AppSettingsState {
  Settings: AppSetting[];
  ApplicationNavigation: number[];
  IsLoaded: boolean;
}
